import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import store from "app/api/redux/store";

import RecordNotifications from "app/features/RecordNotification";

import App from "app/components/App";

import "./index.scss";

ReactDOM.render(
  <BrowserRouter>
    <Provider store={store}>
      <App />
      <RecordNotifications />
    </Provider>
  </BrowserRouter>,
  document.getElementById("root")
);
